import {reaction, observable, action} from "mobx"
import SessionStore from '../../services/session/SessionStore';
import {recordEvent} from "./plugins/metricPlugin";

export default {

  /** somewhat clunky method to toggle whether a user is opted into the layout. Toggles the layout if the userId is the current user */
  processAndUpsertUserPreferences({
    userId = SessionStore.user && SessionStore.user.userId,
    userPreferences
  }) {
    const hasOptedIntoNewLayout = userPreferences.useNewLayout && !userPreferences.hasOptedIntoNewLayout
      ? { hasOptedIntoNewLayout: true }
      : {};
    
    // Don't update the view if another user
    const isSameUser = SessionStore.user.userId === userId;
    recordEvent(
      `switched_to_${userPreferences.useNewLayout === true ? "new" : "old"}_layout`,
      { 
        useNewLayout: userPreferences.useNewLayout,
        hasOptedIntoNewLayout: userPreferences.hasOptedIntoNewLayout || false,
        isSameUser
      }
    );

    return SessionStore.patchUserPreferences({
      userId: userId,
      userPreferences: { ...userPreferences, ...hasOptedIntoNewLayout }
    });
  }

}